const total = 'total';
const unpaid = 'unpaid';
const forMe = 'forMe';
const totalPaidByCard = 'totalPaidByCard';
const otherExpenses = 'otherExpenses';
const leftOver = 'leftOver';

export function isMobile() {
  if (typeof window !== "undefined") {
    const regex = /Mobi|Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i;
    return regex.test(navigator.userAgent);
  }
}


export const monthDataDisplay = (monthData, monthValues) => {

const formattedObject = Object.fromEntries(
  Object.entries(monthValues).map(([key, value]) => [
    key,
    Number(value).toFixed(2)
  ])
);

  const result = monthData.map((el) => {
    if (el.valueName === "Оборот:") {
      el.value = formattedObject.overallTotal + " EUR";
      return el;
    } else if (el.valueName === "Гориво:") {
      el.value = formattedObject.otherExpensesTotal + " EUR";
      return el;
    } else if (el.valueName === "Заплащане:") {
      el.value = formattedObject.forMeTotal + " EUR";
      return el;
    } else if (el.valueName === "Неплатени:") {
      el.value = formattedObject.unpaidTotal + " EUR";
      return el;
    } else if (el.valueName === "Чисто:") {
      el.value = formattedObject.leftOverTotal + " EUR";
      return el;
    } else if (el.valueName === "Терминал:") {
      el.value = formattedObject.totalCardPayment + " EUR"
    }
    return el;
  });
  return result;
};


export const calculateMonthPrice = (month) => {

  let totalSum = 0;
  let otherExpensesSum = 0;
  let forMeSum = 0;
  let totalUnpaidSum = 0;
  let totalCardSum = 0;
  let leftOverSum = 0;  
  
       month.forEach((row) => {
        row.forEach((cell) => {
          cell.forEach((data) => {
            switch (data.id) {
              case total:
                if (cell.value !== '') totalSum += Number(data.value);
                  break;
              case unpaid:
                if (cell.value !== '') totalUnpaidSum += Number(data.value);
                  break;
              case forMe:
                if (cell.value !== '') forMeSum += Number(data.value);
                  break;
              case otherExpenses:
                if (cell.value !== '') otherExpensesSum += Number(data.value);
                  break;
              case leftOver:
                if (cell.value !== '') leftOverSum += Number(data.value);
                  break;
              case totalPaidByCard:
                if (cell.value !== '') totalCardSum += Number(data.value);
                  break;
              default: break;
           }
          return data;
          });
         return cell;
     });
     return row;
 });

return  {
    overallTotal: totalSum,
    otherExpensesTotal: otherExpensesSum,
    forMeTotal: forMeSum,
    unpaidTotal: totalUnpaidSum,
    leftOverTotal: leftOverSum,
    totalCardPayment: totalCardSum
  }
}


export const changeDateFormat = (data) => {
  const date = new Date(data);
  const day = date.getDay();

  switch (day) {
    case 1:
      return "Понеделник:";
    case 2:
      return "Вторник:";
    case 3:
      return "Сряда:";
    case 4:
      return "Четвъртък:";
    case 5:
      return "Петък:";
    case 6:
      return "Събота:";
    case 0:
      return "Неделя:";
    default:
      return "";
  }
};